import { useCallback, useMemo } from "react";

import { AppModel, type PriorityV3 } from "@doitintl/cmp-models";
import { getCollection, type WithModel } from "@doitintl/models-any";
import { useDocumentData } from "@doitintl/models-hooks";

import { useApiContext } from "../../../api/context";
import { useCustomerId } from "../../hooks/useCustomerId";
import { PriorityApi, V1Api } from "./api";

export function usePriorityAPI() {
  const customerId = useCustomerId();
  const api = useApiContext();
  return useMemo(() => new PriorityApi(api, customerId), [api, customerId]);
}

export function useV1Api() {
  const customerId = useCustomerId();
  const api = useApiContext();
  return useMemo(() => new V1Api(api, customerId), [api, customerId]);
}

export function useCompanies() {
  const query = useMemo(() => getCollection(AppModel).doc("priority-v3"), []);

  const transform = useCallback((data: WithModel<PriorityV3>) => data.companies, []);

  const [companies] = useDocumentData(query, {
    transform,
  });
  return companies;
}
